import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "section-footer-pages" }
const _hoisted_2 = { class: "section-footer-contact" }

import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faClock, faInbox, faLocationDot, faPhone } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';


export default /*@__PURE__*/_defineComponent({
  __name: 'FooterBottom.component',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", null, [
    _cache[12] || (_cache[12] = _createElementVNode("section", { class: "section-footer-me" }, [
      _createElementVNode("img", {
        class: "logo",
        src: "https://res.cloudinary.com/dyikvzcke/image/upload/v1755469812/LOGO_SKF_1-removebg-preview_zfcosc.webp",
        alt: "Logo de Rodamientos Huanuco"
      }),
      _createElementVNode("p", null, " Distribuidor autorizado de repuestos industriales y automotricez en la marca SKF con mas de 35 años de experiencia. Tambien ofrecemos los productos que necesitas en diferentes marcas. ")
    ], -1)),
    _createElementVNode("section", _hoisted_1, [
      _cache[3] || (_cache[3] = _createElementVNode("h6", null, "Cotiza por WhatsApp", -1)),
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, [
          _createVNode(_unref(FontAwesomeIcon), {
            icon: _unref(faWhatsapp),
            style: {"opacity":"0.7"}
          }, null, 8, ["icon"]),
          _cache[0] || (_cache[0] = _createElementVNode("span", null, " +51 994 247 830", -1))
        ]),
        _createElementVNode("li", null, [
          _createVNode(_unref(FontAwesomeIcon), {
            icon: _unref(faWhatsapp),
            style: {"opacity":"0.7"}
          }, null, 8, ["icon"]),
          _cache[1] || (_cache[1] = _createElementVNode("span", {
            to: "/productos",
            class: "item-option"
          }, " +51 994 247 832", -1))
        ]),
        _createElementVNode("li", null, [
          _createVNode(_unref(FontAwesomeIcon), {
            icon: _unref(faWhatsapp),
            style: {"opacity":"0.7"}
          }, null, 8, ["icon"]),
          _cache[2] || (_cache[2] = _createElementVNode("span", {
            to: "/acerca-de",
            class: "item-option"
          }, " +51 993 381 769", -1))
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_2, [
      _cache[11] || (_cache[11] = _createElementVNode("h6", null, "Encuentranos aquí", -1)),
      _createElementVNode("div", null, [
        _createElementVNode("p", null, [
          _createVNode(_unref(FontAwesomeIcon), {
            icon: _unref(faLocationDot),
            style: {"opacity":"0.7"}
          }, null, 8, ["icon"]),
          _cache[4] || (_cache[4] = _createTextVNode(" Av. Aviacion 1954 Urb. Santa Catalina Lima - 13 Perú. (Referencia) FRENTE A LA VIDENA DEPORTIVA. ", -1))
        ]),
        _createElementVNode("p", null, [
          _createVNode(_unref(FontAwesomeIcon), {
            icon: _unref(faPhone),
            style: {"opacity":"0.7"}
          }, null, 8, ["icon"]),
          _cache[5] || (_cache[5] = _createTextVNode(" (01) 224-8385", -1))
        ]),
        _createElementVNode("p", null, [
          _createVNode(_unref(FontAwesomeIcon), {
            icon: _unref(faInbox),
            style: {"opacity":"0.7"}
          }, null, 8, ["icon"]),
          _cache[6] || (_cache[6] = _createTextVNode(" ventas@skfhuanuco.com", -1))
        ]),
        _createElementVNode("p", null, [
          _createVNode(_unref(FontAwesomeIcon), {
            icon: _unref(faInbox),
            style: {"opacity":"0.7"}
          }, null, 8, ["icon"]),
          _cache[7] || (_cache[7] = _createTextVNode(" huanuco@skfhuanuco.com", -1))
        ]),
        _createElementVNode("p", null, [
          _createVNode(_unref(FontAwesomeIcon), {
            icon: _unref(faClock),
            style: {"opacity":"0.7"}
          }, null, 8, ["icon"]),
          _cache[8] || (_cache[8] = _createTextVNode(" Lunes - Vier 8AM - 6PM ", -1)),
          _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
          _cache[10] || (_cache[10] = _createTextVNode(" Sábados 8AM - 3PM ", -1))
        ])
      ])
    ])
  ]))
}
}

})